export function readAccountForm(data: FormData): { label: string; symbolAlias: string } {
  return {
    label: String(data.get("label") ?? "").trim(),
    // Broker symbols are exact identifiers, including lowercase suffixes.
    symbolAlias: String(data.get("symbolAlias") ?? "").trim(),
  };
}
